import { Avatar } from 'antd';

export interface OrganizationLogoProps {
  name: string;
  logoUrl?: string | null;
}

/** 图片缺失或加载失败时，交给 Avatar 显示用户确认的机构名称缩写。 */
export default function OrganizationLogo({
  name,
  logoUrl,
}: OrganizationLogoProps) {
  const title = name.trim();
  const initials = /^\p{Script=Han}/u.test(title)
    ? [...title][0]
    : title
        .split(/\s+/u)
        .map((word) => [...word][0])
        .join('')
        .toUpperCase();

  return (
    <Avatar
      shape="square"
      size="large"
      src={logoUrl ?? undefined}
      alt={name}
      className="size-10 shrink-0 rounded-xl bg-primary text-sm font-semibold text-white"
    >
      {initials}
    </Avatar>
  );
}
